export const LocalStorage = 1

export const SessionStorage = 2
